module.exports = __webpack_public_path__ + "static/media/align-center-h.f19fa9a0.svg";